import React, { ComponentProps, FunctionComponent } from "react";

const LogoGoogleIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17 17",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M5.13248 6.89798C5.36317 6.20004 5.80838 5.59278 6.40461 5.16284C7.00083 4.73289 7.71761 4.50222 8.45268 4.50373C9.28594 4.50373 10.0393 4.79956 10.631 5.28373L12.3527 3.56249C11.3035 2.64789 9.95895 2.08334 8.45268 2.08334C6.12055 2.08334 4.11285 3.41359 3.14746 5.36213L5.13248 6.89798Z",
      fill: "#EA4335",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M10.4445 10.9645C9.90707 11.3111 9.22469 11.496 8.45257 11.496C7.72043 11.4975 7.00636 11.2687 6.41146 10.8419C5.81656 10.4151 5.37098 9.81203 5.1378 9.11801L3.14587 10.6302C3.63461 11.6194 4.39096 12.4517 5.32901 13.0326C6.26707 13.6135 7.34923 13.9197 8.45257 13.9164C9.89869 13.9164 11.2802 13.4021 12.3151 12.4372L10.445 10.9645H10.4445Z",
      fill: "#34A853",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M12.3149 12.4374C13.3972 11.4277 14.0998 9.92484 14.0998 7.99997C14.0998 7.6499 14.046 7.27371 13.9657 6.92413H8.45239V9.21041H11.6257C11.4694 9.97908 11.0488 10.5742 10.4448 10.9647L12.3149 12.4374Z",
      fill: "#4A90E2",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M5.13789 9.11842C5.01727 8.75796 4.95599 8.3803 4.95645 8.00018C4.95645 7.61462 5.01808 7.24434 5.13247 6.89822L3.14745 5.36237C2.74136 6.18215 2.53203 7.08534 2.53607 8.00018C2.53607 8.94684 2.75548 9.83926 3.14597 10.6306L5.13789 9.11842Z",
      fill: "#FBBC05",
    })
  );
};

const ForwardRef = React.forwardRef(LogoGoogleIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
